'use client'
import React from 'react'
import TeamPlaceholder from '@/assets/images/placeholder/team.png'
import MyImage from '@/shared/components/myImage'
import { S3_PREFIX, BLUR_DATA_URL_BASE64 } from '@/shared/constants'
import { useRouter } from 'next/navigation'
import { getImgURL, getSlugUrl } from '@/shared/utils'

const TeamForm = ({ team, teamData }: any) => {
  const router = useRouter()

  const handleClick = (slug: string) => {
    if (slug) {
      router.push(getSlugUrl(`/${slug}`))
    }
  }

  return (
    <section className="mb-3 mb-md-4">
      <h4 className="text-base md:text-xl text-textOffWhite font-bold mb-4">Team Form</h4>
      <div className={`overflow-hidden`}>
        {team && team?.length > 0 && (
          <div
            className={`bg-cardBg mb-5 cursor-pointer text-base leading-6 border dark:border-c border-tabBorder rounded-2xl font-medium overflow-hidden`}
          >
            <div className="flex px-3.5 py-4 md:pt-[18px] md:pb-6 md:px-6">
              <div className={`flex items-center gap-3 md:gap-4`}>
                <div
                  className={`w-5 h-5 md:w-9 md:h-9 rounded-circle overflow-hidden flex-shrink-0`}
                >
                  <MyImage
                    src={
                      teamData?.oImg?.sUrl ? `${S3_PREFIX}${teamData?.oImg?.sUrl}` : TeamPlaceholder
                    }
                    alt="user"
                    blurDataURL={BLUR_DATA_URL_BASE64}
                    className="aspect-square rounded-full"
                    placeholder="blur"
                    width={36}
                    height={36}
                  />
                </div>
                <p className="text-sm md:text-lg font-medium text-textOffWhite md:text-t-origin mb-0">
                  {teamData?.sTitle}
                </p>
              </div>
              <div className={`flex items-center gap-1 ms-auto`}>
                {team?.map((match: any, index: number) => {
                  return (
                    <div
                      key={index}
                      className={`${'w-6 h-6 rounded dark:text-textOffWhite text-white text-xs font-bold'} ${
                        !match?.oWinner?._id
                          ? 'bg-t-info'
                          : match?.oWinner?._id === teamData?._id
                            ? 'bg-winBg'
                            : 'bg-lossBg'
                      } text-center rounded-circle flex-shrink-0 small-text`}
                    >
                      {!match?.oWinner?._id
                        ? 'D'
                        : match?.oWinner?._id === teamData?._id
                          ? 'W'
                          : 'L'}
                    </div>
                  )
                })}
              </div>
            </div>
            <div className={`${''} mt-0`}>
              {team?.map((match: any, index: number) => {
                return (
                  <div
                    key={index}
                    className={`${' cursor-pointer'} grid grid-cols-3 items-center p-4 border-t border-separator md:p-6`}
                    onClick={() => handleClick(match?.oSeo?.sSlug)}
                  >
                    <div className={`${' '} me-1`}>
                      <div className="flex items-center gap-2.5">
                        <div
                          className={`w-5 h-5 md:w-6 md:h-6 rounded-circle overflow-hidden flex-shrink-0`}
                        >
                          <MyImage
                            src={getImgURL(match?.oTeamScoreA?.oTeam?.oImg?.sUrl)}
                            alt="user"
                            blurDataURL={BLUR_DATA_URL_BASE64}
                            placeholderImage={TeamPlaceholder}
                            className="aspect-square rounded-full"
                            placeholder="blur"
                            width={24}
                            height={24}
                          />
                        </div>
                        <p className="mb-0 text-xs md:text-sm font-bold text-textOffWhite">
                          {match?.oTeamScoreA?.oTeam?.sAbbr || match?.oTeamScoreA?.oTeam?.sTitle}
                        </p>
                        <p className="mb-0 text-xs md:text-sm text-textDselected font-medium hidden md:block">
                          <span className="mb-0 font-bold text-textOffWhite md:text-textDselected">{`${match?.oTeamScoreA?.sScores} `}</span>
                          {`(${match?.oTeamScoreA?.sOvers} ov)`}
                        </p>
                      </div>
                      <p className="m-0 mt-1 block md:hidden text-xs md:text-sm text-textDselected font-medium">
                        <span className="mb-0 font-bold text-textOffWhite md:text-textDselected">{`${match?.oTeamScoreA?.sScores} `}</span>
                        {`(${match?.oTeamScoreA?.sOvers} ov)`}
                      </p>
                    </div>
                    <p
                      className={`text-xxs font-medium md:text-base text-center mb-0 ${
                        !match?.oWinner?._id
                          ? 'text-textDselected'
                          : match?.oWinner?._id === teamData?._id
                            ? 'text-textDselected'
                            : 'text-textDselected'
                      }`}
                    >
                      {match?.sResult || match?.sStatusNote}
                    </p>
                    <div className={`${' '} ms-1 text-end`}>
                      <div className="flex items-center justify-end gap-2.5">
                        <p className="mb-0 text-xs md:text-sm text-textDselected font-medium hidden md:block">
                          <span className="mb-0 font-bold text-textOffWhite md:text-textDselected">{`${match?.oTeamScoreB?.sScores} `}</span>
                          {`(${match?.oTeamScoreB?.sOvers} ov)`}
                        </p>
                        <p className="mb-0 text-xs md:text-sm font-bold text-textOffWhite">
                          {match?.oTeamScoreB?.oTeam?.sAbbr || match?.oTeamScoreB?.oTeam?.sTitle}
                        </p>
                        <div
                          className={`w-5 h-5 md:w-6 md:h-6 rounded-circle overflow-hidden flex-shrink-0`}
                        >
                          <MyImage
                            src={getImgURL(match?.oTeamScoreB?.oTeam?.oImg?.sUrl)}
                            alt="user"
                            placeholderImage={TeamPlaceholder}
                            blurDataURL={BLUR_DATA_URL_BASE64}
                            className="aspect-square rounded-full"
                            placeholder="blur"
                            width={24}
                            height={24}
                          />
                        </div>
                      </div>

                      <p className="m-0 mt-1 block md:hidden text-xs md:text-sm text-textDselected font-medium">
                        <span className="mb-0 font-bold text-textOffWhite md:text-textDselected">{`${match?.oTeamScoreB?.sScores} `}</span>
                        {`(${match?.oTeamScoreB?.sOvers} ov)`}
                      </p>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default TeamForm
